import Vue from 'vue'
import Router from 'vue-router'

const routerOptions = [
  { path: '/',component: 'Login' },
  { path: '/mybooking',component: 'MyBooking', meta: { requiresAuth: true } },
  { path: '/dashboard',component: 'DashBoard', meta: { requiresAuth: true } },
  { path: '/passport',component: 'Passport', meta: { requiresAuth: true }  },
  { path: '/support',component: 'Support' },
  { path: '/logout',component: 'Logout', meta: { requiresAuth: true } }
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior () { return { x: 0, y: 0 }	}

})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = localStorage.getItem("brefcl")
  if (requiresAuth && !isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router